import React, { useContext, useEffect, useState } from "react";
import { AccountContext } from "./Account";
import { useHistory } from "react-router-dom";
import Button from '@material-ui/core/Button';


const Status = () => {
    let history = useHistory();

    const [status, setStatus] = useState(false);

    const { getSession, logout } = useContext(AccountContext);

    const handleLogin = () => {
        history.push('/tic-tac-toe/login');
    }

    useEffect(() => {
        let isMounted = true;
    
        getSession()
          .then((session) => {
            if (isMounted) setStatus(true);
          })
          .catch((err) => {
            console.log("No session or error:", err);
            if (isMounted) setStatus(false);
          });
    
        return () => { isMounted = false }; // cleanup
    }, [getSession]); // run only once on mount
    

    return (
        <div>
            {status ? (
                <div>
                <Button color="secondary" onClick={logout}>Logout</Button> 
                </div>
            )
            : (
                <div>
                <Button color="primary" onClick={handleLogin}>Sign In</Button>
                </div>
            )
            }
            
        </div>
    );
};

export default Status;